import React, { Fragment, useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import _ from "lodash";
import { getAllApplicants, MasiveStateUpdatToApplicant } from "./Axios";
import FieldWrapper from "../commons/FieldWrapper";
import Swal from "sweetalert2";

const MasiveUpdatePostulationState = ({
  buttonSize,
  applicant,
  courseId,
  _applicantsSelected,
  reloadQuery
}) => {
  const [modal, setModal] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const [applicantsSelected, setApplicantsSelected] = useState(
    _applicantsSelected
  );
  const [error, setError] = useState(false);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    const getApplicants = () => {
      const newApplicants = applicants;
      getAllApplicants(courseId, response => {
        _.map(response.data, applicant => {
          newApplicants.push({
            value: applicant.id,
            label: applicant.full_name
          });
        });
      });
      setApplicants(newApplicants);
    };
    if (!applicant) getApplicants();
  }, []);

  useEffect(() => {
    if (modal) {
      setApplicantsSelected(_applicantsSelected);
    } else {
      setApplicantsSelected([]);
      setError(false);
    }
  }, [modal]);

  const handleChangeApplicantsSelected = newValue => {
    if (newValue) {
      setApplicantsSelected(newValue);
      setError(false);
    } else {
      setApplicantsSelected([]);
    }
  };

  const serializeData = () => {
    let formData = new FormData();
    if (applicant) {
      formData.append("applicant_ids[]", applicant.value);
    } else {
      _.map(applicantsSelected, applicant => {
        formData.append("applicant_ids[]", applicant.value);
      });
    }

    formData.append("course_id", courseId);

    return formData;
  };

  const handleSubmit = () => {
    if (!applicant && applicantsSelected.length === 0) {
      setError(true);
      return;
    }

    setError(false);
    const data = serializeData();

    MasiveStateUpdatToApplicant(data, response => {
      if (response.status !== 200) {
        Swal.fire("Error", "Ocurrió un problema al actualizar las postulaciones.", "error");
        return;
      }

      const { data: applicants } = response;
      const total = applicants.length;
      const errors = applicants.filter(applicant => applicant.errors.length > 0);
      const successful = total - errors.length;

      const errorTranslations = {
        "rejected": "No se puede aprobar una postulación rechazada.",
        "approved": "Postulación ya aprobada."
      };

      const formatErrors = errors
        .map(({ full_name, errors }) => {
          const translatedErrors = errors.map(err => errorTranslations[err] || err).join(", ");
          return `<li class="fs-6 list-unstyled"><strong>${full_name}:</strong> ${translatedErrors}</li>`;
        })
        .join("");

      const message = `
        <p><strong>Usuarios procesados correctamente:</strong> ${successful}/${total}</p>
        ${errors.length > 0 ? `<p><strong>Detalles:</strong></p><ul>${formatErrors}</ul>` : ""}
      `;

      Swal.fire({
        title: "Resultado del proceso",
        html: message,
        icon: errors.length > 0 ? "warning" : "success",
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.isConfirmed) {
          reloadQuery();
        }
      });

      toggle();
    });
  };

  return (
    <Fragment>
      <Button color="primary" size={buttonSize} outline onClick={toggle}>
        Aceptar postulación
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          Aceptar Postulaciones
        </ModalHeader>
        <ModalBody>
          {applicant ? (
            <p>
              Candidato(a): <strong>{applicant.label}</strong>
            </p>
          ) : (
            <FieldWrapper errors={error ? ["Debe seleccionar candidatos"] : []}>
              <Select
                isMulti
                placeholder="Seleccione Candidatos"
                options={applicants}
                onChange={handleChangeApplicantsSelected}
                value={applicantsSelected}
              />
            </FieldWrapper>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmit}>
            Aceptar
          </Button>{" "}
          <Button color="danger" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default MasiveUpdatePostulationState;